export const DEFAULT_MENU_THEME = "classic";

export const MENU_THEMES = [
  {
    key: "classic",
    label: "کلاسیک",
    description: "طراحی پیش‌فرض میزبان؛ ساده، سریع و مناسب هر نوع کسب‌وکار.",
    colors: ["#F88225", "#1F2937", "#F9FAFB"],
  },
  {
    key: "gardenFresh",
    label: "گاردن فرش",
    description: "الهام‌گرفته از غذای سالم و طبیعت؛ سبز، گرم و ارگانیک.",
    colors: ["#3F5A3D", "#F5F1E6", "#B65C34"],
  },
  {
    key: "japaneseMinimal",
    label: "ژاپنی مینیمال",
    description: "مینیمال و آرام؛ مناسب رستوران‌های ژاپنی، سوشی و آسیایی.",
    colors: ["#B3231C", "#F7F3EC", "#1C1C1C"],
  },
  {
    key: "brewBites",
    label: "کافه و بیسکوییت",
    description: "گرم و صمیمی؛ مناسب کافه، کافی‌شاپ و شیرینی‌فروشی.",
    colors: ["#4A2E23", "#FBF3E7", "#C68A4E"],
  },
  {
    key: "nova",
    label: "نوا",
    description: "روشن و پرانرژی؛ مناسب غذای سالم و رستوران‌های مدرن.",
    colors: ["#F5793B", "#FFFFFF", "#1F2937"],
  },
  {
    key: "mizbanSignature",
    label: "امضای میزبان",
    description: "شیک و اختصاصی؛ سبز تیره و طلایی برای رستوران‌های درجه‌یک.",
    colors: ["#153A2E", "#F8F5EC", "#C79A4B"],
  },
  {
    key: "luxuryWhite",
    label: "لوکس سفید",
    description: "شیک و مینیمال؛ سفید و طلایی برای فضاهای فاین‌دایینینگ.",
    colors: ["#C9A44C", "#FFFFFF", "#2B2620"],
  },
  {
    key: "streetFood",
    label: "فست‌فود خیابانی",
    description: "پرانرژی و جسورانه؛ مناسب برگرفروشی و فست‌فود خیابانی.",
    colors: ["#151515", "#F5C518", "#FFFFFF"],
  },
  {
    key: "royalGold",
    label: "رویال",
    description: "تیره و مجلل؛ مناسب رستوران‌های لوکس و فاین‌دایینینگ.",
    colors: ["#0D0D0D", "#C9A227", "#FFFFFF"],
  },
  {
    key: "persianHeritage",
    label: "میراث ایرانی",
    description: "سنتی و اصیل؛ مناسب رستوران‌های سنتی و ایرانی.",
    colors: ["#0F3D3E", "#C9A44C", "#F7F1E1"],
  },
];

export const getMenuThemeMeta = (key) => (
  MENU_THEMES.find((theme) => theme.key === key) || MENU_THEMES[0]
);
